import { FiltroAdminGlosas, Glosa, SolicitudAdminGlosa } from "../modelo/AdminGlosas";

export const CONSULTAR_GLOSAS_ADMIN = "CONSULTAR_GLOSAS_ADMIN";
export const GLOSAS_CONSULTADAS_ADMIN = "GLOSAS_CONSULTADAS_ADMIN";
export const ERROR_CONSULTANDO_GLOSAS_ADMIN = "ERROR_CONSULTANDO_GLOSAS_ADMIN";

export const GESTIONAR_GLOSA_ADMIN = "GESTIONAR_GLOSA";
export const GESTION_GLOSA_ADMIN_EXITO = "GESTION_GLOSA_ADMIN_EXITO";
export const GESTION_GLOSA_ADMIN_ERROR = "GESTION_GLOSA_ADMIN_ERROR";
export const LIMPIAR_MENSAJES_GLOSAS = "LIMPIAR_MENSAJES_GLOSAS";

export const VENTANA_AYUDA_GLOSA = "VENTANA_AYUDA_DESPLEGADA";

export const consultarGlosasSAT = (filtro: FiltroAdminGlosas) => ({ type: CONSULTAR_GLOSAS_ADMIN, filtro});
export const glosasConsultadas = (datosEntidad: Array<Glosa>, paginas: number, totalDatos: number) => ({ 
    type: GLOSAS_CONSULTADAS_ADMIN, datosEntidad, paginas, totalDatos });
export const errorConsultandoGlosas = () => ({ type: ERROR_CONSULTANDO_GLOSAS_ADMIN });

export const gestionarGlosaSAT = (solicitud: SolicitudAdminGlosa) => ({ type: GESTIONAR_GLOSA_ADMIN, solicitud});
export const gestionExito = () => ({ type: GESTION_GLOSA_ADMIN_EXITO});
export const gestionError = (mensaje: string) => ({ type: GESTION_GLOSA_ADMIN_ERROR, mensaje});
export const limpiarMensajesGlosas = () => ({type: LIMPIAR_MENSAJES_GLOSAS});

export const ventanaAyudaGlosa = () => ({type: VENTANA_AYUDA_GLOSA});





// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_glosas/modulos/adminGlosaActions.ts